import { useEffect, useState } from 'react';
import { days, months } from '../utils/utilities';

export const useMonthAndDateSelect = () => {
  const [day, setDay] = useState<number>(0);
  const [month, setMonth] = useState<number>(0);
  const [dayOptions, setDayOptions] = useState<number[]>(days);
  const [monthOptions, setMonthOptions] = useState<number[]>(months);

  useEffect(() => {
    if (month === 2) {
      setDayOptions(days.filter((item) => item <= 29));
      if (day >= 29) {
        setDay(1);
      }
    } else if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
      setDayOptions([...days]);
    } else if ([4, 6, 9, 11].includes(month)) {
      setDayOptions(days.filter((item) => item <= 30));
    }
    if (!month) {
      setDayOptions([...days]);
    }
    if (day === 30) {
      setMonthOptions(months.filter((item) => item !== 2));
    } else if (day === 31) {
      setMonthOptions(months.filter((item) => item !== 2 && item !== 4 && item !== 6 && item !== 9 && item !== 11));
    } else {
      setMonthOptions([...months]);
    }
  }, [month, day]);

  return { day, setDay, month, setMonth, dayOptions, monthOptions };
};
